import dasarPemrogramanWeb from "../../images/certificates/dasarpemrogramanweb.png";
import belajarFundamentalAplikasiAndroid from "../../images/certificates/belajarfundamentalaplikasiandroid.png";
import aplikasiAndroidUntukPemula from "../../images/certificates/aplikasiandroidpemula.png";
import kade from "../../images/certificates/kade.png";
import mpdk from "../../images/certificates/mpdk.png";
import mpdp from "../../images/certificates/mpdp.png";
import bffwd from "../../images/certificates/bffwd.png";
import solid from "../../images/certificates/solid.png";
import hki from "../../images/certificates/hki.png";

const dataCertificates = [
    {
        title: "Belajar Dasar Pemrograman Web",
        issuer: "Dicoding",
        subtitle: "Berlaku sampai 5 April 2023",
        type: "Sertifikasi",
        image: dasarPemrogramanWeb,
        imageAlt: "Sertifikat Dicoding Belajar Dasar Pemrograman Web",
        url: "https://www.dicoding.com/certificates/MEPJLO1DJZ3V"
    },
    {
        title: "Belajar Fundamental Aplikasi Android",
        issuer: "Dicoding",
        subtitle: "Berlaku sampai 7 Mei 2024",
        type: "Sertifikasi",
        image: belajarFundamentalAplikasiAndroid,
        imageAlt: "Sertifikat Dicoding Belajar Fundamental Aplikasi Android",
        url: "https://www.dicoding.com/certificates/JLX11E8ENX72"
    },
    {
        title: "Belajar Membuat Aplikasi Android untuk Pemula",
        issuer: "Dicoding",
        subtitle: "Berlaku sampai 8 Maret 2024",
        type: "Sertifikasi",
        image: aplikasiAndroidUntukPemula,
        imageAlt: "Sertifikat Dicoding Belajar Membuat Aplikasi Android untuk Pemula",
        url: "https://www.dicoding.com/certificates/98XW6O6QWXM3"
    },
    {
        title: "Kotlin Android Developer Expert",
        issuer: "Dicoding",
        subtitle: "Berlaku sampai 6 Januari 2023",
        type: "Sertifikasi",
        image: kade,
        imageAlt: "Sertifikat Dicoding Kotlin Android Developer Expert",
        url: "https://www.dicoding.com/certificates/07Z6L803RPQR"
    },
    {
        title: "Memulai Pemrograman dengan Kotlin",
        issuer: "Dicoding",
        subtitle: "Berlaku sampai 9 Agustus 2022",
        type: "Sertifikasi",
        image: mpdk,
        imageAlt: "Sertifikat Dicoding Memulai Pemrograman dengan Kotlin",
        url: "https://www.dicoding.com/certificates/GRX5GO5GVX0M"
    },
    {
        title: "Memulai Pemrograman dengan Python",
        issuer: "Dicoding",
        subtitle: "Berlaku sampai 23 Oktober 2023",
        type: "Sertifikasi",
        image: mpdp,
        imageAlt: "Sertifikat Dicoding Memulai Pemrograman dengan Python",
        url: "https://www.dicoding.com/certificates/QLZ919M5EP5D"
    },
    {
        title: "Belajar Prinsip Pemrograman SOLID",
        issuer: "Dicoding",
        subtitle: "Berlaku sampai 5 Maret 2024",
        type: "Sertifikasi",
        image: solid,
        imageAlt: "Sertifikat Dicoding Belajar Prinsip Pemrograman SOLID",
        url: "https://www.dicoding.com/certificates/RVZK4WNJNPD5"
    },
    {
        title: "Belajar Fundamental Front-End Web Developer",
        issuer: "Dicoding",
        subtitle: "Berlaku sampai 9 April 2023",
        type: "Sertifikasi",
        image: bffwd,
        imageAlt: "Sertifikat Dicoding Belajar Fundamental Front-End Web Developer",
        url: "https://www.dicoding.com/certificates/RVZK10234PD5"
    },
    {
        title: "Aplikasi Web Inventarisasi Peminjaman Alat dan Ruang Laboratorium",
        issuer: "HKI",
        subtitle: "Nomor 000153438",
        type: "Hak Kekayaan Intelektual",
        image: hki,
        imageAlt: "Dokumen HKI Aplikasi Web Inventarisasi Peminjaman Alat dan Ruang Laboratorium",
        url: "https://drive.google.com/file/d/0BzqdzcKbCLmydkVuVm5RRUt0Z0U1V2I0SkNkWlprRXBfQ2Jv/view?resourcekey=0-SngQDCOriPqsQgjpO2hYcw"
    },
    {
        title: "Aplikasi Pemantauan Cuaca Pesisir Kebumen",
        issuer: "HKI",
        subtitle: "Nomor 000182900",
        type: "Hak Kekayaan Intelektual",
        image: hki,
        imageAlt: "Dokumen HKI Aplikasi Pemantauan Cuaca Pesisir Kebumen",
        url: "https://drive.google.com/file/d/1E0sQyAKVICgoYe_3vNPLHRZLwZJiTBlZ/view"
    },
    {
        title: "Aplikasi Media Informasi Covid-19",
        issuer: "HKI",
        subtitle: "Nomor 000252729",
        type: "Hak Kekayaan Intelektual",
        image: hki,
        imageAlt: "Dokumen HKI Aplikasi Media Informasi Covid-19",
        url: "https://drive.google.com/file/d/1xjxdUS8X19ZtkY8Cns8gDfDoEfNd-_BR/view"
    },
    {
        title: "Aplikasi Cek RPS",
        issuer: "HKI",
        subtitle: "Nomor 000206345",
        type: "Hak Kekayaan Intelektual",
        image: hki,
        imageAlt: "Dokumen HKI Aplikasi Cek RPS",
        url: "https://drive.google.com/file/d/1d588TUBV48hdEeG0KdfQIP0y9BsQzaSI/view"
    },
    {
        title: "Application Programming Interface Autograding Apps",
        issuer: "HKI",
        subtitle: "Nomor 000260126",
        type: "Hak Kekayaan Intelektual",
        image: hki,
        imageAlt: "Dokumen HKI Application Programming Interface Autograding Apps",
        url: "https://drive.google.com/file/d/16euML1nQJNipQHMch7GTW-8o7xGEGMS-/view"
    },
    {
        title: "BankSampahKu",
        issuer: "HKI",
        subtitle: "Nomor 000260057",
        type: "Hak Kekayaan Intelektual",
        image: hki,
        imageAlt: "Dokumen HKI BankSampahKu",
        url: "https://drive.google.com/file/d/1EX-VvYbGCQf-IErXjrTvQE2U0OQE19KV/view"
    },
];

export default dataCertificates;
